import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs} from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
Swiper.use([Navigation, Pagination, Autoplay, Thumbs ]);

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

(function ($) {
    let menuWidth = 1280;
    let subMenuClass = '.edu-main-menu .current-menu-item .sub-menu, .edu-main-menu .current-page-ancestor .sub-menu';
    let subSubMenuClass = '.edu-overlay-menu .menu > li.menu-item-has-children .edu-submenu ul > li.menu-item-has-children  > ul.sub-menu > li.menu-item-has-children > ';
    eduLoadtwoCalendar();

    let arrLeonardGTMTrackingFormPath = [
      "/fr/infolettre/",
      "/fr/contactez-nous/",
      "/fr/tester-mon-francais/",
      "/fr/inscrivez-vous/",
      "/fr/devenir-agent-edu-inter/",
      "/fr/devenir-famille-accueil-edu-inter/",
      "/fr/a-propos/carriere/candidature-spontanee/",
      "/newsletter/",
      "/contact/",
      "/test-your-french/",
      "/register/",
      "/become-edu-inter-agent/",
      "/become-homestay-family/",
      "/about-us/career/spontaneous-application/",
      "/es/boletin/",
      "/es/contactanos/",
      "/es/contactanos/gracias/",
      "/es/poner-prueba-frances/",
      "/es/registrate/",
      "/es/se-agente-edu-inter/",
      "/es/quienes-somos/carrera/aplicacion-espontanea/",
    ]
  
    let baseFontSize = 16;
    let examPrice = 0;
    let tefExamId = '#sf_comprehension-ecrite, #sf_comprehension-orale, #sf_expression-orale, #sf_expression-ecrite';
    $(document).on('change', tefExamId, eduSelectedExam);
    $(document).on('change', '#sf_00NA0000007egxu', eduSelectedTest);
    $(document).on('change', '#sf_Date', eduSelectedDate);
    eduSelectedExam();
    eduSelectedDate();
    eduSelectedTest();
  
    $(document).ready(function () {
      eduRedirectContactForm();
      initLeonardGTMTracking();

      $(document).on('touchstart', '.edu-main-menu .menu > li.menu-item-has-children > a', eduTouchStart);

      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 50) {
        $(".edu-menu").addClass("scrolled");
      }

      if ($(".edu-articles-swiper").length) {
        eduArticlesSwiper();
      }
      if ($(".edu-programs-swiper").length) {
        eduProgramsSwiper();
      }
      if ($(".edu-programs-info-swiper").length) {
        eduProgramsInfoSwiper();
      }

      $(document).on("click", ".edu-menu-open", eduOpenMenu);
      $(".edu-overlay-menu .menu > li.menu-item-has-children > a").on('click', eduHeaderOpenSubMenu);
      $(".edu-overlay-menu .menu > li.menu-item-has-children .edu-submenu ul > li.menu-item-has-children > a").on('click', eduHeaderOpenSubSubMenu);
      $(subSubMenuClass + "a, " + subSubMenuClass + 'span').on('click', eduHeaderOpenSubSubSubMenu);
      $(document).on('click', '.edu-menu-mobile-open .menu-icon, .edu-overlay-menu .menu-icon.close-icon', eduToggleOverlayMenu);
      $(document).on('click', '#edu_search, #edu_search_mobile', eduToggleSearch);
      $(document).on('click', '.edu-overlay-search .menu-icon.close-icon', eduToggleSearch);
      $(document).on('click', '#edu_calendar_month_prev, #edu_calendar_month_next, #edu_calendar_month_prev_2, #edu_calendar_month_next_2', eduCalendarSkipMonth);
      $(document).on('click', '#edu_calendar_month_current', eduCalendarTriggerMonth);
      $(document).on('click', '#edu_calendar_month_current_2', eduCalendarTriggerMonth2);
      $(document).on('click', '#MonthPicker_edu_calendar_month_input .month-picker-month-table .ui-button', eduCalendarChangeMonth);
      $(document).on('click', '#MonthPicker_edu_calendar_month_input_2 .month-picker-month-table .ui-button', eduCalendarChangeMonth2);
      $(document).on('change', '#edu_calendar_program_type', eduCalendarChangeType);
      $(document).on('change', '#edu_calendar_program_type_2', eduCalendarChangeType2);
      $(document).on('click', '#to-top', eduScrollToTop);

      if($('.programDetails').length || $('.programCultur').length){
        window.addEventListener("load", updateAccordion);
        window.addEventListener("resize", updateAccordion);
      }

      $(window).on("resize", eduResize);

      $(window).scroll(function () {
        debounce(eduHandleScroll, 25);
      });

      $(document).on("keyup", "#edu-searchpage-input", function () {
        let keyword = "";
        let lang = "/";
        if ($(this).val() != "") {
          keyword = lang + "?s=" + $(this).val();
        }
        $("#edu_search_form").attr("action", keyword);
      });

      $("#edu-search-input").keyup(delay(ajaxSearch, 500));

      $("#edu-search-input").on("search", ajaxClearSearch);

      if($('.edu-flexible-slider .edu-flexible-swiper').length){
        eduFlexibleSwiper();
      }
      if($('.edu-flexible-testimonies .edu-flexible-testimonies-swiper').length){
        eduFlexibleTestimoniesSwiper();
      }

      if($('.single-job .edu-block-form .wpcf7-hidden[name="job_name"]').length) {
        $('.single-job .edu-block-form .wpcf7-hidden[name="job_name"]').val($('h1').text());
      }
  });

  function eduTouchStart(e){
    if(window.innerWidth > menuWidth) {
      $('.edu-main-menu').addClass('prevent-tablet');
    }
  }

  function eduHandleScroll() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 50) {
      $(".edu-menu").addClass("scrolled");
      $(".edu-menu").removeClass("scrolled-top");
    }
    if (scrollTop == 0) {
      $(".edu-menu").removeClass("scrolled");
      $(".edu-menu").addClass("scrolled-top");
    }
  }

  function eduSelectedExam(){
    examPrice = 0;
    let checked = false;
    $('.edu-exam-selected').empty();
    $(tefExamId).each(function(index){
      if($(this).is(':checked')){
        checked = true;
        switch($(this).val()){
          case 'expression-ecrite':
          case 'comprehension-ecrite':
            examPrice = examPrice + 90;
            break;
          case 'comprehension-orale':
          case 'expression-orale':
            examPrice = examPrice + 160;
            break;
        }
        $('.edu-exam-selected').append('<span>-' + $(this).next().text() + '</span>');
      }
    });
    if(checked){
      $('.edu-price-combined').text(examPrice + '$');
      $('.tef-price-exam-cash-price').text(examPrice);
    }
    else{
      $('.edu-price-combined').text('0,00$');
      $('.tef-price-exam-cash-price').text('0,00');
    }
  }
  function eduSelectedTest(){
    if($('#sf_00NA0000007egxu').find(":selected").val()){
      $('.edu-test-selected').text($('#sf_00NA0000007egxu').find(":selected").text());
    }
    
  }
  function eduSelectedDate(){
    if($('#sf_Date').find(":selected").val()){
      $('.edu-date-selected').text($('#sf_Date').find(":selected").text());
    }
  }

  function ajaxSearch(e) {
    let perPage = 3;
    let paginate = 0;
    if (e.target.id == "edu-searchpage-input") {
      perPage = 12;
      paginate = 1;
    }
    if ($(this).val() == "") {
      ajaxClearSearch(e);
    } else {
      $.ajax({
        beforeSend: function () {
          $(".search-loading").removeClass("hidden");
        },
        url: ajax.url,
        type: "post",
        data: {
          action: "edu_search_results",
          keyword: $(this).val(),
          perPage: perPage,
          paginate: paginate,
        },
        success: function (data) {
          if (e.target.id == "edu-searchpage-input") {
            jQuery("#edu_searchpage_results").html(data);
          } else {
            jQuery("#edu_search_results").html(data);
          }

          $(".search-loading").addClass("hidden");
        },
      });
    }
  }

  function ajaxClearSearch(e) {
    if (e.target.id == "edu-searchpage-input") {
      jQuery("#edu_searchpage_results").empty();
    } else {
      jQuery("#edu_search_results").empty();
    }
  }

  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId = setTimeout(function () {
      method();
    }, delay);
  }

  function delay(callback, ms) {
    var timer = 0;
    return function () {
      var context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  function eduToggleSearch(){
    if($('.edu-overlay-menu').hasClass('opened')){
      eduToggleOverlayMenu();
    }
    $('body').toggleClass('opened');
    $('.edu-menu').toggleClass('search-opened');

    if($('.edu-menu').hasClass('search-opened')) {
      $('input.edu-search').focus();
    }
  }

  function eduOpenMenu() {
    $("header.edu-menu").toggleClass("edu-menu-opened");
    $(".edu-menu-open").toggleClass("edu-menu-close");
  }

  function eduHeaderOpenSubMenu(e) {
    e.preventDefault();
    e.stopPropagation();
    eduOpenSubMenu(this, 'edu-submenu');
    return false;
  }

  function eduHeaderOpenSubSubMenu(e) {
    e.preventDefault();
    e.stopPropagation();
    eduOpenSubMenu(this, 'sub-menu');
    return false;
  }

  function eduHeaderOpenSubSubSubMenu(e) {
    e.preventDefault();
    e.stopPropagation();
    eduOpenSubMenu(this, 'edu-submenu-2');
    return false;
  }

  function eduOpenSubMenu(el, subMenuClass) {
    let subMenuSelected = "";
    let isOpened = $(el).parent().hasClass('opened') ? true : false;
    let allSubMenu = $(el)
      .parent()
      .parent()
      .find("."+subMenuClass)
      .not($(el).parent().find("."+subMenuClass));

    subMenuSelected = $(el).parent().find("."+subMenuClass).first();
    
    let allMenuLi = $(el).closest('ul.menu').children('li').not($(el).parents('li'));

    $(el).parent().removeClass('opened');
    $(el).closest('ul.sub-menu').children('li').removeClass('opened');
    allMenuLi.removeClass('opened');

    if(!isOpened){
      $(el).parent().addClass('opened');
    }

    allSubMenu.removeClass(subMenuClass+"-opened");
    subMenuSelected.toggleClass(subMenuClass+"-opened");
  }


  function eduResize(e) {
    let winWidth = window.innerWidth;
    if (winWidth > menuWidth) {
      $(".edu-main-menu .sub-menu").removeClass("sub-menu-opened");
      $(".edu-main-menu .menu > li > a").removeClass(
        "edu-sub-menu-selected"
      );
      $(".edu-menu-open").removeClass("edu-menu-close");
      $("header.edu-menu").removeClass("edu-menu-opened");
    } else {
      $(".edu-main-menu .sub-menu").removeAttr("style");
    }
  }

  function pxToRem(pxValue) {
    const remValue = pxValue / baseFontSize;
    return remValue;
  }

  function eduToggleOverlayMenu(){
    $('.edu-overlay-menu').toggleClass('opened');
    $('body').toggleClass('opened');
    if($('.edu-menu').hasClass('search-opened')){
      $('.edu-menu').removeClass('search-opened')
    }
  }

  function eduFlexibleSwiper(){
    let flexibleSlider;

    $('.edu-flexible-slider .edu-flexible-swiper').each(function() {
      let flexibleSliderParent = $(this).parents('.edu-flexible-slider');

      flexibleSlider = new Swiper('#' + flexibleSliderParent.attr('id') + ' .edu-flexible-swiper', {
        spaceBetween: 10,
        loop: true,
        pagination: {
          el: ".edu-flexible-slider#" + flexibleSliderParent.attr('id') + " .swiper-pagination",
          clickable: true,
        },
      });
    });
  }

  function eduFlexibleTestimoniesSwiper(){
    let flexibleTestimoniesSlider;

    $('.edu-flexible-testimonies .edu-flexible-testimonies-swiper').each(function() {
      let flexibleSliderParent = $(this).parents('.edu-flexible-testimonies');

      flexibleTestimoniesSlider = new Swiper('#' + flexibleSliderParent.attr('id') + ' .edu-flexible-testimonies-swiper', {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        pagination: {
          el: ".edu-flexible-testimonies#" + flexibleSliderParent.attr('id') + " .swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
          }
        }
      });
    });
  }
  
  let programDetailsList = document.querySelectorAll(".programDetails");
  let programCulturList = document.querySelectorAll(".programCultur");

  function updateAccordion() {
    if (window.innerWidth >= 768) {
      toggleOpenAttribute(programDetailsList, true);
      toggleOpenAttribute(programCulturList, true);
    } else {
      toggleOpenAttribute(programDetailsList, false);
      toggleOpenAttribute(programCulturList, false);
    }
  }
  function toggleOpenAttribute(elements, isOpen) {
    elements.forEach(function (element) {
      if (isOpen) {
        element.setAttribute("open", "open");
      } else {
        element.removeAttribute("open");
      }
    });
  }

  //swipers

  function eduArticlesSwiper() {
    let swiperArticlesTypeSlider = new Swiper(".edu-articles-swiper", {
      slidesPerView: 1.2,
      spaceBetween: 50,
      autoplay: false,
      breakpoints: {
        600: {
          slidesPerView: 2.2,
        },
        900: {
          slidesPerView: 3,
        },
      },
    });
  }
  function eduProgramsSwiper() {
    let swiperProgramsTypeSlider = new Swiper(".edu-programs-swiper", {
      slidesPerView: 1.2,
      spaceBetween: 50,
      autoplay: false,
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
      },
    });
  }
  function eduProgramsInfoSwiper() {
    let swiperProgramsInfoTypeSlider = new Swiper(".edu-programs-info-swiper", {
      slidesPerView: 1.2,
      spaceBetween: 50,
      autoplay: false,
      breakpoints: {
        600: {
          slidesPerView: 2.2,
        },
        900: {
          slidesPerView: 3,
        },
      },
    });
  }
  function eduRedirectContactForm() {
    document.addEventListener('wpcf7mailsent', function (event) {
      let redirectUrl = $('input[name=redirect_url]').val();

      if (redirectUrl != undefined) {
        location = redirectUrl;
      }
    }, false);
  }
  function eduCalendarSkipMonth(){
    let dateCurrent = $(this).data('date');
    let termId = $(this).data('termid');
    eduAjaxMonthCalendarFiltered(dateCurrent);
  }
  function eduCalendarTriggerMonth(){

    $('#edu_calendar_month_input').click();
  }
  function eduCalendarTriggerMonth2(){
    $('#edu_calendar_month_input_2').click();
  }
  function eduCalendarChangeMonth(){
    eduAjaxMonthCalendarFiltered($('#edu_calendar_month_input').val());
  }
  function eduCalendarChangeMonth2(){
    eduAjaxMonthCalendarFiltered($('#edu_calendar_month_input_2').val());
  }
  function eduCalendarChangeType(){
    eduAjaxMonthCalendar($('#edu_calendar_month_input').val(), $(this).val(), $(this).children(":selected").data("type"));
  }
  function eduCalendarChangeType2(){
    eduAjaxMonthCalendar($('#edu_calendar_month_input_2').val(), $(this).val(), $(this).children(":selected").data("type"));
  }
  function eduAjaxMonthCalendarFiltered(dateVal){
    let termId = null;
    let filterType = null;
    if($('#edu_calendar_program_type').val()){
      termId = $('#edu_calendar_program_type').val();
      filterType = $('#edu_calendar_program_type option:selected').data("type");
    }
    eduAjaxMonthCalendar(dateVal, termId, filterType);
  }
  function eduAjaxMonthCalendar(dateCurrent, termId, filterType){
    if(!dateCurrent && $('#edu_calendar_month_current').data('date')){
      dateCurrent = $('#edu_calendar_month_current').data('date');
    }
    else if(!dateCurrent){
      dateCurrent = new Date().toISOString().slice(0, 10);
    }

    $.ajax({
        type: "post",
        url: ajax.url,
        data: { action: 'edu_calendar_skip_month', dateCurrent: dateCurrent, post_type: $('#post_type_calendar').val(), termId: termId, filterType: filterType},
        beforeSend: function(){

        },
        success: function(data){
          $('.edu-calendar-month-container').empty();
          $(data).appendTo('.edu-calendar-month-container');
          
          eduLoadtwoCalendar();
        }
    });
  }
  function eduLoadtwoCalendar(){
    if($('#edu_calendar_month_input').length){
      $('#edu_calendar_month_input').MonthPicker({
        Button: false,
        MinMonth: 0,
        MaxMonth: '+2y',
        MonthFormat: 'yy-mm'
      });
    }
    if($('#edu_calendar_month_input_2').length){
      $('#edu_calendar_month_input_2').MonthPicker({
        Button: false,
        MinMonth: 0,
        MaxMonth: '+2y',
        MonthFormat: 'yy-mm'
      });
    }
  }
  function eduScrollToTop() {
    $(window).scrollTop(0);
  }

  function initLeonardGTMTracking() {
    // Track CTA pointing to a «Leads Form»
    // -------
    var arrLeonardGTMTrackingCTA = [];
    for(var i=0; i<arrLeonardGTMTrackingFormPath.length; i++){
      arrLeonardGTMTrackingCTA.push("a.btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
    }

    // Custom CSS rules here
    // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");

    $(arrLeonardGTMTrackingCTA.join("", "")).addClass("gtm-form-view");

    // Track «Leads form» submit button click
    // -------
    if(arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
      $("form button, form input[type=submit]").addClass("gtm-form-submited");

      if(window.location.pathname == '/newsletter/'|| window.location.pathname == '/fr/infolettre/' || window.location.pathname == '/es/boletin/') {
        $("form.w2llead").addClass("gtm-form-submited");
      }
    }
  }
})(jQuery);